export default __webpack_public_path__ + "static/media/tp-loja-virtual.f7c415c7.webp";